import { Autocomplete, Typography } from '@mui/material';
import React from 'react';
import { StyledTextField } from './StyledTextField';

type AutocompleteSelectProps = Omit<React.ComponentProps<typeof Autocomplete<any>>, 'renderInput'> & {
  label?: string;
  error?: boolean;
  helperText?: string;
  textFieldProps?: React.ComponentProps<typeof StyledTextField>;
};

export const AutocompleteSelect = React.forwardRef<unknown, AutocompleteSelectProps>(
  ({ label, error, helperText, textFieldProps, ...props }, ref) => {
    return (
      <Autocomplete
        ref={ref}
        forcePopupIcon={textFieldProps?.focused}
        renderInput={(params) => (
          <div className="flex flex-col">
            <Typography sx={{ fontSize: '12px', color: '#1B3D5599', mb: 1 }}>{label}</Typography>
            <StyledTextField
              {...params}
              error={error}
              helperText={helperText}
              variant="standard"
              slotProps={{
                ...params.slotProps,
                input: {
                  ...(params.slotProps?.input as object),
                  className: `${textFieldProps?.focused ? 'py-3 pl-6' : 'pb-[0]'} duration-200 linear`,
                  disableUnderline: true,
                  autoComplete: 'new-password',
                },
                inputLabel: {
                  ...(params.slotProps?.inputLabel as object),
                  shrink: true,
                },
              }}
              {...textFieldProps}
            />
          </div>
        )}
        {...props}
      />
    );
  },
);
